import { useEffect, useState } from "react";

/**
 * False during SSR and the first client render, true afterwards.
 * Use it to gate anything that reads persisted browser state (localStorage-backed
 * stores), which would otherwise cause a hydration mismatch (React error #418).
 */
export function useHydrated() {
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => setHydrated(true), []);
  return hydrated;
}
